import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const {
  Background: {
    SecondaryNav: { Default: SecondaryNavBackgroundColor },
  },
  SeparatorBorder,
} = themeColorSectionKeys.defaults

const ContactsListViewParts = [
  'vstack',
  'toggleButton',
  'searchContainer',
  'dropdownContainer',
  'listContainer',
  'scrollingList',
] as const

const helpers = createMultiStyleConfigHelpers(ContactsListViewParts)

export const ContactsListViewStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    vstack: {
      display: 'flex',
      height: '100%',
      alignSelf: 'stretch',
      gap: '2px',
      borderRight: '2px solid',
      borderColor: SeparatorBorder,
    },
    toggleButton: {
      width: 'full',
      minHeight: '2rem',
      bg: SecondaryNavBackgroundColor,
    },
    searchContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'stretch',
      backgroundColor: SecondaryNavBackgroundColor,
    },
    dropdownContainer: {
      width: '100%',
      padding: '1rem',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1.25rem',
      alignSelf: 'stretch',
      backgroundColor: SecondaryNavBackgroundColor,
      zIndex: 1,
    },
    scrollingList: {
      display: 'flex',
      flex: '1',
      width: '100%',
      height: '70%',
      backgroundColor: SecondaryNavBackgroundColor,
      paddingX: '0.25rem',
      paddingY: '0.75rem',
    },
  },
})

export const useContactsListViewStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ContactsListViewParts>(
    getName({ ContactsListViewStyle }),
    props,
  )
}
